import { convertEvaluationType } from '../../../../api/enumerations';
import { BankDossier } from '../../../../api/workOrders/bankDossier';
import { WorkOrderData } from '../../../../api/workOrders/types';
import { Constants } from '../../../../constants/bankDossier';
import {
  booleanLabel,
  documentOrEmpty,
  moneyOrEmpty,
  percentOrEmpty,
} from '../../../../helpers/bankDossier';
import {
  BooleanField,
  Field,
  FieldGrid,
  FieldGroup,
  FieldGroups,
} from '../../../UI/FieldGrid';

interface SectionProps {
  dossier: BankDossier;
  workOrder: WorkOrderData;
}

const { fields } = Constants.financing;

export function FinancingSection({
  dossier,
  workOrder,
}: SectionProps): JSX.Element {
  const { financing, identification } = dossier;

  return (
    <>
      <FieldGroup title={Constants.financing.infoTitle}>
        <FieldGrid minColumn={220}>
          <Field
            label={fields.control}
            value={identification.bank_control_number}
            emphasis
            mono
          />
          <Field
            label={fields.originalProposal}
            value={financing.original_proposal_number}
            mono
          />
          <Field
            label={fields.previousProposal}
            value={financing.previous_proposal_number}
            mono
          />
          <Field
            label={fields.operationType}
            value={financing.operation_type}
          />
          <Field label={fields.requestKind} value={financing.request_kind} />
          <Field
            label={fields.owner}
            value={financing.property_owner}
            span={2}
          />
          <Field
            label={fields.proponent}
            value={financing.proponent_name}
            span={2}
          />
          <Field
            label={fields.proponentDocument}
            value={documentOrEmpty(financing.proponent_document)}
            mono
          />
          <Field
            label={fields.eligibility}
            value={financing.proponent_eligibility}
          />
          <BooleanField label={fields.fgts} value={financing.uses_fgts} />
          <Field
            label={fields.purpose}
            value={financing.credit_line_purpose}
            span={2}
          />
        </FieldGrid>
      </FieldGroup>

      <FieldGroups>
        <FieldGroup title={Constants.financing.valuesTitle}>
          <FieldGrid minColumn={160}>
            <Field
              label={fields.purchaseValue}
              value={moneyOrEmpty(financing.purchase_sale_value)}
              mono
            />
            <Field
              label={fields.financingValue}
              value={moneyOrEmpty(financing.financing_value)}
              mono
            />
            <Field
              label={fields.propertyValue}
              value={moneyOrEmpty(financing.property_value)}
              mono
            />
            <Field
              label={fields.ltv}
              value={percentOrEmpty(financing.ltv)}
              mono
            />
            <Field
              label={fields.appraisalValue}
              value={moneyOrEmpty(dossier.appraisal_value)}
              emphasis
              mono
            />
          </FieldGrid>
        </FieldGroup>

        <FieldGroup title={Constants.financing.reportTitle}>
          <FieldGrid minColumn={160}>
            <Field
              label={Constants.financing.reportTitle}
              value={convertEvaluationType(workOrder.evaluation_type)}
            />
            <Field
              label={fields.originalReport}
              value={dossier.report_kind.original_report_reference}
            />
            <Field
              label={fields.fgts}
              value={booleanLabel(financing.uses_fgts)}
            />
          </FieldGrid>
        </FieldGroup>
      </FieldGroups>
    </>
  );
}
